import React, {useEffect, useMemo, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import {Spinner, Form, Row, Col, Button} from 'react-bootstrap';
import { refiFiles, purchaseFiles, fixAndFlipFiles } from '../Data/RequiredLoanData';
import { MAX_FILE_SIZE } from '../Data/MaxData';
// import { MAX_FILE_SIZE } from '../Data/MaxData';

const AdminUploadModal = (props) => {
    const credentials = props.credentials
    const ClientID = props.ClientID
    const loan = props.loan
    const uploadedFiles = props.uploadedFiles
    const setUploadedFiles = props.setUploadedFiles
    const isAdmin = props.isAdmin
    const [fileName, setFileName] = useState("Certificate of Formation - Articles of Organization")
    const [fileIndex, setFileIndex] = useState(0)
    const [previewFileCache, setPreviewFileCache] = useState([]);
    const [isUploading, setIsUploading] = useState(false)
    const fileList = useMemo(() => {
        let tempFileList = []
        if (loan.LoanType == "Refinance"){
            refiFiles.forEach((file) => tempFileList.push({"fileName": file.fileName, "maxUploads": file.maxUploads}))
        }else if(loan.LoanType == "Purchase"){
            purchaseFiles.forEach((file) => tempFileList.push({"fileName": file.fileName, "maxUploads": file.maxUploads}))
        }else if(loan.LoanType == "Fix and Flip"){
            fixAndFlipFiles.forEach((file) => tempFileList.push({"fileName": file.fileName, "maxUploads": file.maxUploads}))
        }else{
            alert("Error. Loan Type Invalid.")
            props.onHide()
        }
        return tempFileList
    },[loan])

    const handleSelectChange = (data) => {
        data = data.split(",")
        setFileName(data[0])
        setFileIndex(data[1])
    }

    // When click on a fileName to preview, display the file in a seperate tab and cache the file
    const handlePreviewFile = (filePath) => {
        const handleClickedPreview = async (filePath) => {

            try{
                const urlResponse = await fetch('https://f0ll5x1c4l.execute-api.us-east-1.amazonaws.com/downloadFileFromS3', {
                "method": "POST",
                "body":JSON.stringify({
                    "filePath":filePath,
                    "credentials": credentials
                })
                });
                if (urlResponse.ok){
                const presignedData = await urlResponse.json();
                const fetchedFileResponse = await fetchFileFromS3(presignedData, filePath);

                }else{
                console.log("Something went wrong when trying to get a presigned url. response not ok.")
                alert("An error occured while retireiving the file for viewing.")
                }
            }catch (error){
                console.error("Something went wrong when getting or using the presigned url to view the file. Error: ", error)
                alert("An error occured while retireiving the file for viewing.")
            }        
        };
        
        const fetchFileFromS3 = async (urlData, fileName) => {
            try{     
                const response = await fetch(urlData, {responseType: "arrayBuffer"});
                
                if (response.ok){
                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
                // cache the file
                setPreviewFileCache([...previewFileCache, {url, name: fileName}]);
    
    
                }else{
                console.error("Something went wrong when fetching the file. Response not ok!")
                alert("An error occured while retireiving the file for viewing.")
                }
    
            }catch (error){
                console.error("Something went wrong when trying to view the file.",  error)
                alert("An error occured while retireiving the file for viewing.")
            }
        }
        
        
            
        const cacheIndex =  previewFileCache.findIndex(f => f.name === filePath);
        
        // If the file is cached, open it from fileCache.
        // If not, call handleClickedPreview to fetch from s3
        if (cacheIndex !== -1){
            console.log("Opening file from cache...");
            let url  = previewFileCache[cacheIndex].url
            window.open(url, '_blank');
        }else{
            console.log("File not cached. Fetching file from S3...");
            handleClickedPreview(filePath);
        }      

    }

    const handleFileChange = async(event) => {
        setIsUploading(true)
        let uploadingFiles = []
        let filePaths = []
        for (let i = 0; i < event.target.files.length; i++){
            uploadingFiles.push(event.target.files[i]);
        };

        uploadingFiles.forEach((file) => {
            let fullName = ClientID + "/" + loan.LoanID + "_" + fileName + "_" + file.name
            if (uploadedFiles[fileName].includes(fullName)){
            alert("The file " + fullName.split("/")[1] + " already exists and will not be added again.")
            }else{
            filePaths.push(fullName);
            }
        });

        // Remove any empty filepaths
        filePaths = filePaths.filter((filePath) => filePath)

        // Make sure that there will not be more than 10 files uploaded for any field
        let totalFileCount = uploadedFiles[fileName].length + filePaths.length

        if (totalFileCount > 10){
            alert("You can only upload up to ten files for this field.")
        }else if (filePaths.length > 0){
            // Using a presigned url (urlData.url), save the file to s3
            const handleUploadToS3 = async (file, urlData) => {
                const formData = new FormData();
                
                Object.keys(urlData.fields).forEach(key => {
                formData.append(key, urlData.fields[key]);
                });
                formData.append('file', file);

                const response = await fetch(urlData.url, {
                method: 'POST',
                body: formData,
                });
            
                return response;
            }
    
            // For each file that was uploaded
            for (let i = 0; i < uploadingFiles.length; i++){
                let uploadedFile = uploadingFiles[i];
                if (uploadedFile.size <= MAX_FILE_SIZE){
                    let filePath = filePaths[i];  

                    try {
                    // Get the pre-signed URL from the Lambda function
                    const presignedResponse = await fetch('https://f0ll5x1c4l.execute-api.us-east-1.amazonaws.com/saveFileToS3',{
                        "method": "POST",
                        "body": JSON.stringify({
                            "filePath": filePath,
                            "credentials": credentials
                        }) 
                    });
                    
                    if (presignedResponse.ok){
                        const presignedData = await presignedResponse.json();
                        try{
                            const uploadResponse = await handleUploadToS3(uploadedFile, presignedData);
                            const isUploaded = uploadResponse.ok
                            if (isUploaded) {
                                console.log("File uploaded successfully to S3!")

                                // Put the file in the preview file cache
                                const url = URL.createObjectURL(uploadedFile);
                                setPreviewFileCache([...previewFileCache, {url, name:filePath}])
                            }else{
                                const error = await uploadResponse.json()
                                alert(error);
                            }
                        }catch (error){
                            console.error(error)
                            alert("Something went wrong while trying to upload the file.    " + error);
                            filePaths.splice(i, 1);
                        }
                    }else{
                        const error = await presignedResponse.json()
                        console.log("Response not ok. ", error)
                        alert(error)
                        filePaths.splice(i, 1);
                    }
                    

                    }catch (error){
                    console.error("something went wrong when getting the presigned url. ", error)
                    alert("Something went wrong while trying to upload the file.   ", error)
                    filePaths.splice(i, 1);
                    }
            
                }else{
                    alert("Error uploading " + filePaths[i] + ". File too large. Try uploading a file less than 10 MB.")
                }  
            }

            
            if (filePaths.length > 0) {
                let tempUploadedFiles = {...uploadedFiles}
                let tempFieldFiles = uploadedFiles[fileName]?[...uploadedFiles[fileName]]:[]
                tempFieldFiles = [...uploadedFiles[fileName], ...filePaths]
                tempUploadedFiles[fileName] = tempFieldFiles

                // Save the new filePath to dynamodb
                const params = {
                method: "POST",
                    body: JSON.stringify({
                        "ClientID": ClientID,
                        "LoanID": loan.LoanID,
                        "updateCategory": "Loan Files",
                        "updatedInfo": tempUploadedFiles,
                        "credentials": credentials
                    })
                }

                const updateUrl = "https://f0ll5x1c4l.execute-api.us-east-1.amazonaws.com/updateLoanInfo";

                try {
                    const response = await fetch(updateUrl, params);

                    if (response.ok) {
                        alert("The file was uploaded successfully!");  
                        setIsUploading(false)         
                        
                    } else {
                        let errorMsg = response.statusText
                        if (response.status == 400){
                            errorMsg = await response.json()
                        }
                        alert("Something went wrong while saving the new file. " + errorMsg)
                        console.log("Something went wrong while saving the new file name to the data base. " + errorMsg)
                        setIsUploading(false)
                    }
                }catch (e){
                    alert("Something went wrong while saving the new file. " + e)
                    console.log("Something went wrong while saving the new file name to the data base. " + e)
                    setIsUploading(false)
                }
                // Save the new filePath to all relevant state variables
                setUploadedFiles(tempUploadedFiles)
            }
        }
        setIsUploading(false)
    }
    return(
        <Modal
            show = {true}
            onHide = {props.onHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size='lg'
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Upload a File for {loan.ClientName}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p className = "red">**Once uploaded, files can only be deleted by the client. Check twice before uploading any files.**</p>
                <Form.Select className='my-2' aria-label="sort-options" onChange = {(event) => handleSelectChange(event.currentTarget.value)}>
                    {fileList.map((file, index) => (
                        <option key = {index} value = {file.fileName + "," + index} id = {file.fileName}>{file.fileName}</option>
                    ))}
                </Form.Select>

                <div className = "mt-3"><span className='bold'>Uploaded File(s):</span>

                    <ul>
                        {((uploadedFiles && fileName && uploadedFiles[fileName]) && uploadedFiles[fileName].length > 0)?(
                            uploadedFiles[fileName].map((filePath, index) => (
                            <Row xs={1} md = {2} lg= {2}>
                                <Col xs = {12} lg = {8}>
                                    <a href="#files" onClick = {() => handlePreviewFile(filePath)}>
                                        <li key = {index}>
                                            {filePath.split("/")[1].split("_")[2]}
                                        </li>
                                    </a>
                                </Col>
                            </Row>
                            ))):(
                            <li>No files were uploaded yet.</li>
                        ) }
                    </ul>
                    {(isAdmin && uploadedFiles && ((!(uploadedFiles[fileName])) || uploadedFiles[fileName].length <= 0 || fileList[fileIndex].maxUploads == "multiple")) && (
                        <Row xs = {2} sm = {2} md = {2} lg = {2} xl = {2} className = "g-4">
                            {isUploading && (
                            <Col xs = {1} sm = {1} md = {1} lg = {1} xl = {1}>
                                <Spinner
                                    as="span"
                                    size = "md"
                                    animation='border'
                                    role='status'
                                    aria-hidden = 'true'
                                >
                                    <span className='visually-hidden'>Loading...</span>
                                </Spinner>
                            </Col>)}
                            <Col>
                                <Form.Control 
                                    as = "input"
                                    type="file" 
                                    size="sm" 
                                    style={{ backgroundColor: 'transparent' }} 
                                    onChange={(e) => handleFileChange(e)} 
                                    id = {fileName}
                                />
                            </Col>
                        </Row>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AdminUploadModal;